import type { PlayerId, UnitKind } from "@dailywars/core/engine";

import { getSpriteUnitIconSrc } from "#/game/unitSprites";

export function UnitAxisTick({
  kind,
  player,
  x,
  y,
}: {
  kind: UnitKind;
  player: PlayerId;
  x: number | string;
  y: number | string;
}) {
  return (
    <image
      x={Number(x) - 48}
      y={Number(y) - 24}
      width={48}
      height={48}
      href={getSpriteUnitIconSrc(kind, player)}
    />
  );
}
